/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-10 17:05:03
 */ 
export const memberInquirySheetCn = {
    xunjiadang:'询价单',
    kaishishijian:'开始时间',
    jieshushijian:'结束时间',
    shushuru:'请输入订单号关键字',
    sousuo:'搜索',
    quanbuzixundang:'全部咨询单',
    baojiazhong:'报价中',
    yibaojia:'已报价',
    yixiadang:'已下单',
    yiquxiao: "已取消",
    zhixundangneirong:'咨询单内容',
    jiage:'价格',
    zhuantai:'状态',
    caozuo:'操作',
    hanghemingcheng:'行业名称',
    fuwuleimu:'服务类目',
    fuwumingcheng:'服务名称',
    xunjiadanhao: "咨询单号：",
    xiadansj: "下单时间：",
    jianyansf: "检验省份：",
    jianyancs: "检验城市：",
    zhanwu: "暂无",
    daibaojia: "待报价",
    querenbaojia: "确认报价",
    jinruxunjiadan: "进入询价单",
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/memberInquirySheet/memberInquirySheetCn.js